import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-schenker',
  standalone: true,
    imports: [CommonModule, SharedUiAlertModule],
  templateUrl: './tekst-schenker.component.html',
  styleUrl: './tekst-schenker.component.scss',
})
export class TekstSchenkerComponent {}
